import useAuth from './useAuth';

const usePermission = () => {
  const auth = useAuth();
  
  const isCaptaOrganization = (): boolean => {
    return (auth?.user?.organization_id ?? -1) === 2;
  };

  const isCaptaRol = (): boolean => {
    return (auth?.user?.role?.id ?? -1) === 1 || (auth?.user?.role?.id ?? -1) === 0;;
  };

  const isAdminRol = (): boolean => {
    return (auth?.user?.role?.id ?? -1) === 2;
  };

  return {
    isCaptaOrganization,
    isCaptaRol,
    isAdminRol,
  };
};

export default usePermission;
